
<div class="dashboard-leaves">
  <div class="title">{{message}}</div>
  <div class="data textL" *ngIf="!doctorLeaves?.length">-- No leaves --</div>
  <div *ngIf="doctorLeaves?.length" style="height: 215px; overflow-y: auto">
    <div class="data" *ngFor="let leave of doctorLeaves"><span>{{leave.get('user').get('DoctorDisplayName') || leave.get('user').get('username')}}</span><span *ngIf="leave.get('holidayType') === 'WeeklyOff'"> (Weekly Off)</span></div>
  </div>
</div>